import { Component, OnInit } from '@angular/core';
import {CinchDataService} from "../../common/service/cinch-data.service";
import {UtilitiesService} from "../../common/service/utilities.service";
import {DashboardData, ServiceHistoryItem} from "../../common/model/cinchAppViewData.model";
import {ApiClaimsHistory, ApiClaimsHistoryV1} from "../../common/model/cchsApiContractData.model";

declare function require(url: string);
declare var jQuery:any;

@Component({
  selector: 'app-service-requests',
  templateUrl: './service-requests.component.html',
  styleUrls: [ './service-requests.component.scss']
})
export class ServiceRequestsComponent implements OnInit {

    dataIsSet = true; // true or false
    serviceHistory: ServiceHistoryItem[] = [];

  constructor(private util:UtilitiesService,
              private cinchData: CinchDataService) { }

  ngOnInit() {
      this.cinchData.claimsData$.subscribe((claims) => {
          this.dataIsSet = false;
          this.serviceHistory = [];
          if ((claims) && (claims.length > 0 )){

              this.serviceHistory = (this.cinchData.testMode)?
                  this.cinchData.getClaimHistoryOnFormatV1(<ApiClaimsHistoryV1[]>claims) :
                  this.cinchData.getClaimHistoryOnFormat(<ApiClaimsHistory[]>claims);

           //   console.log("DashboardComponent set dashboardData.serviceHistory", this.serviceHistory);

          }
          jQuery(document).ready(function() {
              jQuery('[data-toggle="tooltip"]').tooltip();
          });
          this.dataIsSet = true;
      } , e => console.log() );
  }


  goto( route ){
    this.util.goTo(route);
  }
}
